var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, Utils, PacemEventTarget } from './_default-imports';
import { CustomElementUtils } from '../../utils-customelement';
//namespace Pacem.Components {
let PacemStyleProxyElement = class PacemStyleProxyElement extends PacemEventTarget {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'cssText':
                if (!Utils.isNull(this._style)) {
                    this.cssReady = false;
                    this._style.textContent = val;
                    if (Utils.isNullOrEmpty(val)) {
                        this.cssReady = true;
                    }
                    else {
                        this._idleWhileReady();
                    }
                }
                break;
            case 'disabled':
            case 'src':
                this._fetch();
                break;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        const style = this._style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        document.head.appendChild(style);
        this._fetch();
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._style)) {
            this._style.remove();
        }
        super.disconnectedCallback();
    }
    _idleWhileReady() {
        let css = this._style.sheet;
        let fn = () => {
            try {
                if (css.cssRules.length > 0) {
                    clearInterval(handle);
                    CustomElementUtils.Theme.importWebFonts().then(_ => {
                        this.cssReady = true;
                        this.dispatchEvent(new Event('cssready'));
                    });
                }
            }
            catch (e) { }
        };
        let handle = setInterval(fn, 100);
    }
    _fetch() {
        const src = this.src, style = this._style;
        if (this.disabled || Utils.isNull(style)) {
            return;
        }
        if (Utils.isNullOrEmpty(src)) {
            style.textContent = this.cssText || '';
        }
        else {
            // fetching
            this.cssReady = false;
            fetch(src).then(resp => {
                resp.text().then(css => {
                    style.textContent = css;
                    this._idleWhileReady();
                }, _ => {
                    // error
                    this.cssReady = true;
                });
            }, _ => {
                // error
                this.cssReady = true;
            });
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemStyleProxyElement.prototype, "src", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemStyleProxyElement.prototype, "cssText", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemStyleProxyElement.prototype, "cssReady", void 0);
PacemStyleProxyElement = __decorate([
    CustomElement({
        tagName: P + '-style-proxy'
    })
], PacemStyleProxyElement);
export { PacemStyleProxyElement };
//}
